import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@material-ui/core/Dialog';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import 'font-awesome/css/font-awesome.min.css';
import '../styles/bizofficer-a.css';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

var vertical='top',horizontal='center';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  var deviceType = localStorage.getItem('deviceType');
  const [open, setOpen] = React.useState(false); 
  ///const [joinMyStudyRoomWaitLoading, setJoinMyStudyRoomWaitLoading] = React.useState(false);
  const [waitLoading, setWaitLoading] = React.useState(false);
  const [payNowWaitLoading, setPayNowWaitLoading] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  const [payableAmount, setPayableAmount] = React.useState(0);
  const [code, setCode] = React.useState("");
  const [applyPromoCodeLoading, setApplyPromoCodeLoading] = React.useState(false);
  const [applyPromoCodeDone, setApplyPromoCodeDone] = React.useState(false);
  const [priceList, setPriceList] = React.useState([]);
  const [selPriceList, setSelPriceList] = React.useState([]);

  const [selectedPack, setSelectedPack] = React.useState(0);
  const [packToggle, setPackToggle] = React.useState(0);
  const [packToggleBtn, setPackToggleBtn] = React.useState(1);

  const packSelected = {border: '2px solid #0F9D58', borderRadius: 10, backgroundColor: '#FFF', margin: 20, padding: 10};
  const packNonSelected = {border: '1px solid #FFF', borderRadius: 10, backgroundColor: '#E7F1FD', margin: 20, padding: 10};

  const colrsArr = ['#fdfaeb','#edf8fe'];

  function handleSelectedPack(i) {
    setPayNowWaitLoading(false);
    setSelectedPack(i);
    setPayableAmount(selPriceList[i].salePrice);
  }

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {
    setSelectedPack(0);    
    setWaitLoading(false);
    setPayNowWaitLoading(false);
    setApplyPromoCodeDone(false);
    if(open && props.dataDetail){	
      if(props.dataDetail.twoPriceList){
        //document.write(JSON.stringify(props.dataDetail.twoPriceList));
        setPriceList(props.dataDetail.twoPriceList);
        if(props.dataDetail?.twoPriceList[0]?.list?.length>0){
          setSelPriceList(props.dataDetail.twoPriceList[0].list);
          setPackToggle(0);
        }
        if(props.dataDetail?.twoPriceList[0]?.list?.length>0 && props.dataDetail?.twoPriceList[1]?.list?.length>0){
          setPackToggleBtn(1);
        }else{
          setPackToggleBtn(0);
        }
        if(props.dataDetail?.twoPriceList && props.dataDetail?.twoPriceList?.length>0){
          setPayableAmount(props.dataDetail?.twoPriceList[0]?.list[0]?.salePrice);
        }
  
      }else if(props.dataDetail?.priceList && props.dataDetail?.priceList?.length>0){
        ///document.write(JSON.stringify(props.dataDetail?.priceList));
        setPackToggleBtn(0);
        setPriceList(props.dataDetail?.priceList);
        setSelPriceList(props.dataDetail?.priceList);
        setPayableAmount(props.dataDetail?.priceList[0]?.salePrice);
      }
      setCode("");

    }else{
      setPackToggleBtn(1);
      setPackToggle(0);
      setPriceList([]);
      setSelPriceList([]);
      setCode("");

    }
	}, [props.dataDetail,open]); 

  function addCourse(opt){
    if(opt===2 || opt===3){
      // const email = etlStudentObj?.emailId;
      // if(email && email.length>0 && email!=='null'){
      //   setPayNowWaitLoading(true);
      // }else{
      //   setPayNowWaitLoading(false);
      // }
      setPayNowWaitLoading(true); 
      if(props.dataDetail?.twoPriceList && props.dataDetail?.twoPriceList?.length>0){
        props.toCallSelectCourse(opt,code,props.dataDetail?.twoPriceList[packToggle]?.list[selectedPack]?.packId);
      }else if(props.dataDetail?.priceList && props.dataDetail?.priceList?.length>0){
        props.toCallSelectCourse(opt,code,props.dataDetail?.priceList[selectedPack]?.packId);
      }  
    }else{
      setWaitLoading(true);
      props.toCallSelectCourse(opt,code,0);
    }
	}

  // function joinMyStudyRoom(){
  //     setJoinMyStudyRoomWaitLoading(true);
  //     props.toCallSelectCourse(1,code,1);
	// }

  function applyPromoCode(){
    if(code){
      setPayNowWaitLoading(false);
      setApplyPromoCodeLoading(true);
      getApiPromoCode(code);      
    }
  }

  async function getApiPromoCode(code){
    let axiosHeader = {
      headers:{
        'Content-Type': 'multipart/mixed',
        'loginId': etlStudentObj.loginId,
        'token': etlStudentObj.token,
        'device': 'web'
      }
    };
    let apiURL = API_URL+'/verifypromocodes-multiple-pricing?promoCode='+code+'&courseId='+props.dataDetail.courseId;
    ///alert(apiURL);
    axios.get(apiURL, axiosHeader)
       .then(response => {
        setApplyPromoCodeLoading(false);
       ///console.log("Just Checking >> "+response.data);  
       if(response && response.data && response.data.responseTxt==='success'){
          ///document.write(JSON.stringify(response.data.obj));
          setApplyPromoCodeDone(true);
          setPriceList(response.data.obj);
          if(response.data.obj && response.data.obj.length>0){
            if(props.dataDetail?.twoPriceList && props.dataDetail?.twoPriceList?.length>0){
              setSelPriceList(response.data.obj[packToggle].list);
              setPayableAmount(response.data.obj[packToggle].list[selectedPack].salePrice);

            }else{
              setSelPriceList(response.data.obj);
              setPayableAmount(response.data.obj[selectedPack].salePrice);

            }
          }
          setSeverityAlert("success");
          setShowAlert(true);
          setAlertMessage("Promotional code has been applied successfully.");			
          return false;
       }else if(response && response.data && response.data.responseTxt==='invalid'){
          setSeverityAlert("error");
          setShowAlert(true);
          setAlertMessage("Promotional code is invalid.");			
          return false;

       }else if(response && response.data && response.data.responseTxt==="invalidToken"){
          window.localStorage.clear(); 
          window.location.href='logout';
                       
       }else{
          setSeverityAlert("error");
          setShowAlert(true);
          setAlertMessage("Something wrong with promotional code to apply.");			
          return false;
       }				 				
    })
  }

  const handlePackToggle = (event, newValue) => {
    
    if(newValue!=null && newValue>-1){
      setPayNowWaitLoading(false);
      setSelectedPack(0);
      setPackToggle(newValue);  
      
      setSelPriceList(priceList[newValue]?.list);
      setPayableAmount(priceList[newValue]?.list[0]?.salePrice);
    
      // if(newValue==='ACE'){
      //   setPackToggleIndex(1);
      //   setSelPriceList(priceList[1]?.list);
      //   setPayableAmount(priceList[1]?.list[0]?.salePrice);
      // }else{
      //   setPackToggleIndex(0);
      //   setSelPriceList(priceList[0]?.list);
      //   setPayableAmount(priceList[0]?.list[0]?.salePrice);
      // }
    }
	};
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'90vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div style={{textAlign:'center'}} className="btmbdrgry"><h3>{props.dataDetail.courseTitle}</h3></div>
                  <div style={{textAlign:'center'}}>{props.dataDetail.courseSubTitle}</div>

                  {!props.selectedFlag?
                  <Box>
                    <Grid container spacing={2} >
                        <Grid item md={12} sm={12} xs={12}  >
                          <div style={{textAlign:'center', marginTop:10, marginBottom:10}} > 
                                {waitLoading?
                                <LoadingButton loading={waitLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Wait</LoadingButton>
                                :<Button onClick={() => {addCourse(1)}} style={{marginRight:20, textTransform:'none', marginBottom: 10}} size="small" variant="contained" color="primary" >FREE TRIAL</Button>
                                }
                          </div>    
                        </Grid>
                    </Grid>
                  </Box>  
                  :null}

                  {applyPromoCodeDone? 
                    <Box>
                      <Grid container spacing={2} >
                        <Grid item md={12} sm={12} xs={12}  >                            
                            <div style={{textAlign:'center', fontWeight:'bold' }} >
                                <span style={{fontSize:18,color:'#008000'}} >Promo Code Applied</span>                                
                            </div>
                        </Grid> 
                      </Grid>                       
                    </Box>
                    :null}

        {(priceList && priceList.length>0)?                    
                  <div style={{border: '1px solid #f7f7f7',borderRadius: 10, backgroundColor: '#E7F1FD'}} >        
                        <h3 style={{textAlign:'center'}}>Plans</h3> 
                        {packToggleBtn===1?         
                          <Box sx={{ width: '100%', bgcolor: 'background.paper' }} >
                            <Stack spacing={2} alignItems="center">
                            <ToggleButtonGroup
                              color="primary"
                              value={packToggle}
                              exclusive
                              onChange={handlePackToggle}
                              aria-label="Platform"
                              >
                                {(props.packTypesRows || []).filter(obj=>obj.packTypeTitle!=='FREE').map((row,i)=>(
                                    <ToggleButton key={'tb'+i} value={i} style={packToggle===i?{borderColor:'#666', fontSize:12, paddingLeft:30, paddingRight:30, height:25, backgroundColor:'#333', color:'#fff', fontWeight:'bold'}:{borderColor:'#666', fontSize:12, paddingLeft:30, paddingRight:30, height:25}} >{row.packTypeTitle}</ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                            </Stack>
                          </Box>
                        :null}  
                    <Box mt={2}>                    
                    {(selPriceList && selPriceList.length>0)?
                     selPriceList.map((row,i)=>(
                      <div key={'a'+i} style={selectedPack === i?packSelected:packNonSelected}>    
                      <Grid container spacing={2} onClick={()=>{handleSelectedPack(i)}} style={{cursor:'pointer'}} >
                        <Grid item md={6} sm={12} xs={12}  >
                          <Grid container >
                            <Grid item xs={1}  >
                              {selectedPack === i?<CheckIcon style={{color:'#0F9D58'}} />:
                              <input type="radio" name="radio-buttons" value={i} onChange={()=>{handleSelectedPack(i)}} style={{width:20,height:20}} />
                              }
                            </Grid>
                            <Grid item xs={11}  >
                              <div style={{marginLeft:10 }} >
                                  <div>
                                    <div style={{fontWeight:'bold'}}>{row.title}</div>
                                    {row.validityType===1?row.validityDate:null} 
                                    {(row.packType && row.packType.length>0)?<div style={{fontWeight:'bold'}} >{row.packType}</div>:null}
                                    </div>
                                    <div style={props.selectedFlag?{fontWeight:'bold',fontSize:15,color:'#0F9D58' }:{fontSize:12,color:'#0F9D58' }} >
                                      {row.discount>0?<span>SAVE {row.discount}%</span>:null}
                                    </div>
                              </div>
                            </Grid>
                          </Grid>                                    
                        </Grid> 
                        {/* <Grid item md={4} sm={12} xs={12}  >
                              <div style={{textAlign:'center'}}>                            
                                  <div style={{fontWeight:'bold'}}>Validity up to {row.validityDate}</div>
                              </div>
                        </Grid>  */}
                        <Grid item md={6} sm={12} xs={12}  >
                              <div style={{textAlign:'right'}}>                            
                              <div style={{fontWeight:'bold' }} >
                                    <div style={props.selectedFlag?{fontSize:22,color:'#363A3D'}:{fontSize:18,color:'#363A3D'}} > 
                                      <span className='fa fa-inr' style={{fontSize:15}} />{row.salePrice?row.salePrice.toLocaleString('en-IN'):'0'}
                                    </div>
                                    {row.discount>0?
                                    <div style={props.selectedFlag?{marginTop: -10, fontWeight:'bold',fontSize:15,color:'#999' }:{marginTop: -14, fontWeight:'bold',fontSize:13,color:'#999' }} >
                                        <strike><span className='fa fa-inr' style={{fontSize:15}} />{row.retailPrice?row.retailPrice.toLocaleString('en-IN'):'0'}</strike>
                                    </div>
                                    :null}
                                    {(row.salePrice>0 && packToggleBtn===1)?
                                    <div style={{fontSize:16,color:'#666',fontWeight:'normal'}} > 
                                      <span className='fa fa-inr' style={{fontSize:14}} />{row.salePrice?(Math.round(row.salePrice/row.validityDuration)).toLocaleString('en-IN'):'0'}<span style={{fontSize:11,color:'#999'}}>/day</span>
                                    </div>
                                    :null}
                              </div>
                              </div>
                        </Grid> 
                          
                      </Grid>
                      {(row.description && row.description.length>5)?<div style={{marginLeft:30}}>{row.description}</div>:null}
                      
                      </div>
                    )):null}

                      {/* {(deviceType && deviceType==='ios')?
                          <Box>
                            <Grid container spacing={2} >
                              <Grid item xs={12} style={{fontSize:16, color:'#FF0000', fontWeight:'bold', textAlign:'center'}}  >
                                Note: We apologize for the inconvenience, Online payments are currently unavailable through our mobile app. Please log in to our website to purchase courses or upgrade your packages. Thank you for your understanding. 
                                <br/><br/>
                              </Grid>
                             </Grid> 
                          </Box>:     */}
                          <Box mb={2} >  
                                <Grid container spacing={2} >
                                  <Grid item md={6} sm={12} xs={12}  > 
                                    <div style={{marginLeft:15}} >
                                            <span style={{marginLeft:5}}>Apply promo code if any</span><br/>  
                                            <input type="text" onChange={event => setCode(event.target.value)} value={code} placeholder={'Enter promo code'} style={{marginLeft:5,marginBottom:5,padding: 5}} />
                                            
                                            {applyPromoCodeLoading?
                                              <LoadingButton loading={applyPromoCodeLoading} loadingPosition="start" startIcon={<SaveIcon />} size="small" variant="outlined" style={{backgroundColor:'#cccef9',color:'#000',height:23, marginTop:10, marginBottom:10}} >Wait</LoadingButton>
                                              : <Button onClick={() => {applyPromoCode()}} size="small" variant="outlined" style={{backgroundColor:'#dddbdb',color:'#000',height:23, marginTop:-3, marginLeft:10}} >Apply</Button>
                                              }
                                              <br/>
                                            {(props.dataDetail.promoList && props.dataDetail.promoList.length>0)?props.dataDetail.promoList.map((myPC,pcKey)=>(  
                                            <span key={'pca'+pcKey} style={{marginLeft:5}}><i class="fa fa-tags" style={{color:'#7b7b7b'}}></i> {myPC.description}</span>
                                            )):null}                                    
                                    </div>
                                  </Grid>  
                                  <Grid item md={6} sm={12} xs={12} >
                                    <div style={{textAlign:'right',marginRight:'10%',marginTop:20}}>
                                        {
                                          payNowWaitLoading?
                                          <LoadingButton loading={payNowWaitLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#15181B',color:'#FFF'}}  size="small" variant="contained" >Wait</LoadingButton>
                                          :(deviceType && deviceType==='ios')?<Button onClick={() => {addCourse(3)}} size="small" variant="contained" style={{backgroundColor:'#15181B',color:'#FFF',textTransform:'none', marginBottom: 10}} >{(payableAmount<1 && applyPromoCodeDone)?<>Get it free</>:applyPromoCodeDone?<>JUST PAY&nbsp;&nbsp;<span className='fa fa-inr' />{payableAmount}</>:<>Pay Now</>}</Button>
                                          :<Button onClick={() => {addCourse(2)}} size="small" variant="contained" style={{backgroundColor:'#15181B',color:'#FFF',textTransform:'none', marginBottom: 10}} >{(payableAmount<1 && applyPromoCodeDone)?<>Get it free</>:applyPromoCodeDone?<>JUST PAY&nbsp;&nbsp;<span className='fa fa-inr' />{payableAmount}</>:<>Pay Now</>}</Button>
                                        }
                                    </div>
                                    {/* {payableAmount} */}
                                  </Grid>
                              </Grid>
                          </Box>    
                          {/* // } */}

                    </Box>
                  


                    </div>
        :null}

              {props.dataDetail?.featuresList?.length>0?
                  <Box mt={6} className='feacompbox' >
                        <Box className='headingBox'>
                          <h1>Compare Features</h1>
                        </Box>
                        {props.dataDetail?.featuresList?.map((mySec,i)=>(
                          <Box style={i<2?{backgroundColor:colrsArr[i], marginBottom:30, padding: 5, borderRadius:10, border:'1px solid #CCC'}:{marginBottom:30}}>
                            
                            {(mySec.list && mySec.list.length>0)?
                              <h1 style={{textAlign:'center'}}>{mySec.sectionType!=='Others'?mySec.sectionType:null}</h1>
                            :null}

                            {(mySec.list && mySec.list.length>0)?mySec.list.map((myRow)=>(
                            <Box style={{marginBottom:10}}>
                              <Grid container spacing={2}>
                                <Grid item md={12} xs={12}>
                                          <div className='ol-title' >
                                            <h3>{myRow.title}</h3>
                                            <div>
                                              {myRow.description}
                                            </div>
                                          </div>
                                          <Box className='featureBox desktop-section'>
                                            <Grid container spacing={1} style={{backgroundColor:'#E9ECF1'}} >
                                              <Grid item md={6} xs={12} className='ol-border' ><h4>FEATURE</h4></Grid>
                                              {(props.packTypesRowz || []).map((row,i)=>(
                                                <Grid key={'pt'+i} item md={2} xs={12} className='ol-border' ><h4>{row.packTypeTitle}</h4></Grid>
                                              ))}
                                            </Grid>
                                          </Box>
                                          {(myRow.list && myRow.list.length>0)?myRow.list.map((row,j)=>(                                          
                                          <Box className='featureBox' >
                                            <Grid container spacing={1}>
                                              <Grid item md={6} xs={12} className='ol-border feature-title' >{row.title}</Grid>
                                              
                                              {(row.list || []).map((rw,i)=>(
                                                <Grid key={'pck'+i} item md={2} xs={12} className='ol-border' >
                                                  <h5 className='desktop-section'>
                                                    {rw.optionFlag?<div><i className='fa fa-check' /></div>:(!rw.optionLabel || rw.optionLabel==='null' || (rw.optionLabel && rw.optionLabel.length<1) )?<div><i className='fa fa-times' /></div>:null}{rw.optionLabel!=='null'?<>{rw.optionLabel}</>:null}
                                                  </h5>
                                                  <Box className='mobile-section'>
                                                    <Grid container spacing={1} >
                                                      <Grid item xs={3} className='feature-label'>{(props.packTypesRowz && props.packTypesRowz[i].packTypeTitle)}</Grid>
                                                      <Grid item xs={9} >
                                                        <h5>
                                                          {rw.optionFlag?<div><i className='fa fa-check' /></div>:(!rw.optionLabel || rw.optionLabel==='null' || (rw.optionLabel && rw.optionLabel.length<1) )?<div><i className='fa fa-times' /></div>:null}{rw.optionLabel!=='null'?<>{rw.optionLabel}</>:null}
                                                        </h5>
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                </Grid>
                                              ))}


                                            </Grid>
                                          </Box>
                                          )):null}
  
                                </Grid>
                              </Grid>                              
                            </Box> 
                            )):null}

                          </Box>
                          

                        ))}
                  </Box>
                  :
                  <Box mt={6}>
                        <Grid container spacing={2}  >
                          <Grid item md={props.dataDetail.priceType>0?6:12} sm={12} xs={12} >
                            <h2 className='btmbrdrtbl' style={{textAlign:'center',marginBottom: 15}} >MY Study Room™</h2>
                            {
                            props.dataDetail.studyRoom?props.dataDetail.studyRoom.split("\n").map((myRow,index)=>(
                                <>{myRow.indexOf("==")>-1?
                                    <>
                                        <div><b>{myRow.split("==")[0]}</b></div>
                                        <div>{myRow.split("==")[1].indexOf("##")>-1?<ul>
                                          {myRow.split("==")[1].split("##").map((myPoint,indexLi)=>(
                                            <li key={'pt'+indexLi} style={{marginLeft:-23}}>- {myPoint}</li>
                                          ))}
                                        </ul>:<>{myRow.split("==")[1]}</>}</div>
                                    </>:<>{myRow}</>}</>
                              )):null
                            }
                          </Grid> 

                          {props.dataDetail.priceType>0?
                          <Grid item md={6} sm={12} xs={12}  >
                            <h2 className='btmbrdrtbl' style={{textAlign:'center',marginBottom: 15}} >MY Exam Room™</h2>
                            {
                            props.dataDetail.examPrep?props.dataDetail.examPrep.split("\n").map((myRow,index)=>(
                                <>{myRow.indexOf("==")>-1?<>
                                        <div><b>{myRow.split("==")[0]}</b></div>
                                        <div>{myRow.split("==")[1].indexOf("##")>-1?<ul>
                                          {myRow.split("==")[1].split("##").map((myPoint,indexLi)=>(
                                            <li key={'pt'+indexLi} style={{marginLeft:-23}}>- {myPoint}</li>
                                          ))}
                                        </ul>:<>{myRow.split("==")[1]}</>}</div>
                                  </>:<>{myRow}</>}</>
                              )):null
                            }
                          </Grid>  
                          :null}

                        </Grid>   
                  </Box>
                } 
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:20}} size="small" variant="outlined" >Cancel</Button>
                      </Box>  
            </Grid>
          </DialogContent>
      </Dialog>

        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;